import React from 'react';

function LoggingConfig({ data, onChange }) {
  const handleChange = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  const logLevels = [
    { value: 'DEBUG', color: 'text-info', description: 'Detailed information for diagnosing problems' },
    { value: 'INFO', color: 'text-primary', description: 'General information about program execution' },
    { value: 'WARNING', color: 'text-warning', description: 'Warning messages for potential issues' },
    { value: 'ERROR', color: 'text-danger', description: 'Error messages for serious problems' },
    { value: 'CRITICAL', color: 'text-danger', description: 'Critical errors that may cause program termination' }
  ];

  return (
    <div className="row justify-content-center">
      <div className="col-lg-8">
        <div className="card border-0 shadow-sm">
          <div className="card-header bg-warning bg-opacity-10 border-0">
            <h5 className="card-title mb-0 text-warning">
              <i className="bi bi-journal-text me-2"></i>
              Logging Configuration
            </h5>
          </div>
          <div className="card-body">
            <div className="row g-4">
              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  <i className="bi bi-speedometer2 me-1"></i>
                  Log Level
                </label>
                <select 
                  className="form-select form-select-lg" 
                  value={data.level || 'ERROR'} 
                  onChange={(e) => handleChange('level', e.target.value)}
                >
                  {logLevels.map(level => (
                    <option key={level.value} value={level.value}>
                      {level.value}
                    </option>
                  ))}
                </select>
                <div className="mt-2">
                  {logLevels.map(level => (
                    data.level === level.value && (
                      <div key={level.value} className={`small ${level.color}`}>
                        <i className="bi bi-info-circle me-1"></i>
                        {level.description}
                      </div>
                    )
                  ))}
                </div>
              </div>
              
              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  <i className="bi bi-file-earmark-text me-1"></i>
                  Log File Path
                </label>
                <div className="input-group input-group-lg">
                  <span className="input-group-text">
                    <i className="bi bi-folder"></i>
                  </span>
                  <input 
                    type="text" 
                    className="form-control" 
                    value={data.logfile || ''} 
                    onChange={(e) => handleChange('logfile', e.target.value)}
                    placeholder="/tmp/pygeoapi.log"
                  />
                </div>
                <div className="form-text">
                  <i className="bi bi-lightbulb me-1"></i>
                  Leave empty to log to console only
                </div>
              </div>
            </div>
            
            <div className="mt-4 p-3 bg-light rounded">
              <h6 className="text-muted mb-2">
                <i className="bi bi-info-circle me-1"></i>
                Log Level Guide
              </h6>
              <div className="row g-2 small">
                {logLevels.map(level => (
                  <div key={level.value} className="col-12">
                    <span className={`badge ${level.color.replace('text-', 'bg-')} bg-opacity-10 ${level.color} me-2`}>
                      {level.value}
                    </span>
                    {level.description}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoggingConfig;